<!-- TEMPLATE -->
<template>
    <div :class='orderlinesClass'>
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Orderregels</span>
            </span>

            <dean-section-title-item
                :icon='repeatIcon'
                :content="true"
                @click.native="retryMobileProvisioning()"
                v-if="showRetryMobileProvisioningButton()"
            >
              Retry mobile provisioning
            </dean-section-title-item>

            <dean-section-title-item
                :icon='pieChartIcon'
                :content="true"
                @click.native="createPartition()"
                v-if="showPartitionCreationButton()"
            >
              Request partition creation
            </dean-section-title-item>

            <dean-section-title-item
                :icon='uploadCloudIcon'
                :content="true"
                @click.native="provisionServices()"
                v-if="showServiceProvisioningButton()"
            >
              Provision services
            </dean-section-title-item>

            <dean-section-title-item
                :icon='cornerRightUpIcon'
                :content="true"
                @click.native="transferOrderLines()"
                v-if="canTransferOrderLines()"
            >
              Transfer Order Lines to Other Customer (Contract Takeover)
            </dean-section-title-item>

            <dean-section-title-item
                :icon='uploadIcon'
                :content="true"
                @click.native="importOdidoOrderLines()"
                v-if="canImportOdidoOrderLines()"
            >
              Odido bestelregels importeren
            </dean-section-title-item>

            <dean-section-title-item
              :icon='deleteIcon'
              :content="true"
              v-if="canCancelOrderStatus()"
              @click.native="cancelEntireOrder()"
            >
              Alles opzeggen
            </dean-section-title-item>

            <dean-section-title-item
              :icon='plusIcon'
              :content="true"
              @click.native="addOrderline()"
              v-if="canCreateOrderLine()"
            >
              Regel toevoegen
            </dean-section-title-item>
          </dean-section-title>

          <dean-notification>
          </dean-notification>

          <dean-table
            :data='orderlinesData'
            :columns='columns'
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick"
          >
            <span slot="status" slot-scope="status">
                <dean-icon v-for="serviceIcon in status.value.content"
                           :key="serviceIcon.id"
                           className="serviceIcon"
                           :glyph="serviceIcon"
                           width="25"
                           height="25"
                           title="Service">
                </dean-icon>
            </span>
          </dean-table>
          <dean-pagination
            :current-page='orderlinesMetaData.pageNumber'
            :total-items='orderlinesMetaData.totalResults'
            :items-per-page='orderlinesMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='orderlinesMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<!-- SCRIPT -->
<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import {deanDialogBus} from '@/main';
  import {formatPrice} from '@/mixins/formatPrice';
  import {getPhoneNumberFromOrderLine} from '@/mixins/additionalDataPhoneNumber';

  import {
    // SVG
    invoicesIcon,
    ordersIcon,
    deanIcon,
    plusIcon,
    featherIconRepeat,
    featherIconPieChart,
    featherIconCornerRightUp,
    featherIconUploadCloud,
    clockIcon,
    calendarTimeIcon,
    checkmarkIcon,
    warningIcon,
    deleteIcon,
    returnIcon,
    customerIcon,
    globeIcon,
    partnerIcon,
    downloadIcon,
    uploadIcon,
    forbiddenIcon,
    saveIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanSectionTitle,
    deanSectionTitleItem,
  } from '@deanone/dean-components';
  import deanNotification from '@/components/deanComponents/deanNotification.vue';
  import wonIcon from '@/assets/svg/won.svg';
  import statusIcon from '@/assets/svg/status.svg';
  import {statusStringToIcons} from '@/mixins/stringToIcons';
  import {getDutchDateFormat} from '@/mixins/dateWrapper';
  import {getErrorCodeFromResponse, getErrorFromResponse, getErrorMessageFromResponse} from "@/mixins/errorMessage";
  import {OrderStatusEnum, OrderStatusIdEnum} from "@/enums/OrderStatusEnum";
  import {ServiceTagEnum} from "@/enums/ServiceTagEnum";
  import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";
  import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
  import {UserAction} from "@/enums/UserAction";
  import {UserPrivilege} from "@/enums/UserPrivilege";

  @Component({
    components: {
      deanNotification,
      deanPagination,
      deanTable,
      deanSectionTitle,
      deanSectionTitleItem,
      // SVG
      invoicesIcon,
      ordersIcon,
      deanIcon,
      plusIcon,
      clockIcon,
      calendarTimeIcon,
      checkmarkIcon,
      warningIcon,
      deleteIcon,
      returnIcon,
      customerIcon,
      partnerIcon,
      downloadIcon,
      uploadIcon,
      forbiddenIcon,
      featherIconRepeat,
      featherIconCornerRightUp
    },
  })

  export default class List extends mixins(deanTableMixin) {
    // DATA
    public data: any = [];
    public sideMenuData: any = {};
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public pieChartIcon: object = featherIconPieChart;
    public uploadCloudIcon: object = featherIconUploadCloud;
    public repeatIcon: object = featherIconRepeat;
    public cornerRightUpIcon: object = featherIconCornerRightUp;
    public deleteIcon: object = deleteIcon;
    public saveIcon: object = saveIcon;
    public downloadIcon: object = downloadIcon;
    public uploadIcon: object = uploadIcon;
    public enableCancelling: boolean = false;
    public invoiceDate: string = '';
    public orderLineCounts: any = {};
    public simCardCount: number = 0;
    public hasFailedMobileProvisionings: boolean = false;
    public customerId: string|null = null;
    public provisioningAvailable: boolean = false;
    public partitionCreationFailed: boolean = false;
    public partner: any = {
      email: null,
    };
    public partitionDetails: any = {
      identifier: null,
      PBXGroupIdentifier: null,
      status: null,
    };

    public columns: any = {
      productName: {
        content: 'Productnaam',
        align: 'left',
        sort: true,
        dql: 'productName',
      },
      connectAmount: {
        content: 'Eenmalig bedrag',
        align: 'left',
        sort: true,
        dql: 'connectAmount',
      },
      recurrentAmount: {
        content: 'Maandbedrag',
        align: 'left',
        sort: true,
        dql: 'recurrentAmount',
      },
      wishDate: {
        content: 'Wensdatum',
        align: 'left',
        sort: true,
        dql: 'wishDate',
      },
      deliveryDate: {
        content: 'Plandatum',
        align: 'left',
        sort: true,
        dql: 'deliveryDate',
      },
      invoiceDate: {
        content: 'Facturatiedatum',
        align: 'left',
        sort: true,
        dql: 'invoiceDate',
      },
      terminationRequestDate: {
        content: 'Opgezegd wensdatum op',
        align: 'left',
        sort: true,
        dql: 'terminationRequestDate',
      },
      phoneNumbers: {
        content: 'Telefoonnummers',
        align: 'left',
        sort: false,
        dql: 'phoneNumbers',
      },
      status: {
        content: 'Status',
        type: 'slot',
        slot: 'status',
        align: 'center',
        sort: true,
        dql: 'status',
      },
    };

    // COMPUTED
    get orderlinesClass() {
      let value = 'order-orderlines';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get orderlinesMetaData() {
      return this.pageMeta;
    }

    get orderlinesData() {
      return this.data;
    }

    public canEditOrders(): boolean {
      if (authUserHasPrivilegeAndAction(UserPrivilege.ORDER, UserAction.UPDATE)) {
        return true;
      }

      return false;
    }

    public canImportOdidoOrderLines(): boolean {
      if (!this.canEditOrders()) {
        return false;
      }

      return this.data.some(
          (item: any) => (
              item.serviceName === ServiceTypeEnum.MOBILE_ODIDO
          )
      );
    }

    public canCreateOrderLine(): boolean {
      if (authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.CREATE)) {
        return true;
      }

      return false;
    }

    public canCancelOrderStatus(): boolean {
      if (
        this.enableCancelling
        && authUserHasPrivilegeAndAction(UserPrivilege.ORDER, UserAction.CANCEL)
      ) {
        return true;
      }

      return false;
    }

    public canChangeOrderStatus(): boolean {
      if (authUserHasPrivilegeAndAction(UserPrivilege.ORDER, UserAction.CHANGE_STATUS)) {
        return true;
      }

      return false;
    }

    public canTransferOrderLines(): boolean {
      const hasMobileAndInvoicedOrderLine = this.data.some(
          (item: any) => (
              (
                item.serviceName === ServiceTypeEnum.MOBILE_ODIDO
                || item.serviceName === ServiceTypeEnum.MOBILE_KPN
              )
              && item.statusId === OrderStatusIdEnum.INVOICED
              && item.isMainProduct === true
          )
      );

      if (
          hasMobileAndInvoicedOrderLine
          && authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.TRANSFER_ORDER_LINES_TO_CUSTOMER)
      ) {
        return true;
      }

      return false;
    }

    public setCancelling(orderLine: any) {
      if (
        (orderLine.service.name === ServiceTypeEnum.MOBILE_KPN
        && orderLine.status.id === OrderStatusIdEnum.INVOICED)
        || (orderLine.service.name !== ServiceTypeEnum.MOBILE_KPN
        && orderLine.status.id !== OrderStatusIdEnum.TERMINATED)
      ) {
        this.enableCancelling = true;
      }
    }

    public showPartitionCreationButton(): boolean {

      if (this.partitionCreationFailed) {
        return false;
      }

      if (
        authUserHasPrivilegeAndAction(UserPrivilege.PROVISIONING_PARTITION, UserAction.CREATE)
        && this.partitionDetails.status === null
        && this.partitionDetails.status !== 'CREATION_FAILED'
        && this.orderContainsProvisionableProduct()
        && this.orderLinesWithProvisionableProductsAreInStatus(['In Uitvoering', 'Geaccepteerd', 'Gepland'])
      ) {
        return true;
      }

      return false;
    }

    public showRetryMobileProvisioningButton(): boolean {
      if (
          this.hasFailedMobileProvisionings
          && authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.RETRY_MOBILE_ORDER_PROVISIONING)
      ) {
        return true;
      }

      return false;
    }

    public showServiceProvisioningButton(): boolean {
      if (
        authUserHasPrivilegeAndAction(UserPrivilege.PROVISIONING_SERVICE, UserAction.PROVISION)
        && this.provisioningAvailable
        && this.partitionDetails.identifier !== null
        && this.partitionDetails.status === 'created'
        && this.orderContainsProvisionableProduct()
        && this.orderLinesWithProvisionableProductsAreInStatus(['In Uitvoering', 'Geaccepteerd', 'Gepland'])
      ) {
        return true;
      }

      return false;
    }

    public showServiceProvisioningDialog(): boolean {
      if (
          authUserHasPrivilegeAndAction(UserPrivilege.PROVISIONING_SERVICE, UserAction.PROVISION)
          && this.partitionDetails.identifier !== null
          && this.partitionDetails.status === 'created'
          && this.partitionDetails.PBXGroupIdentifier === null
      ) {
        return true;
      }

      return false;
    }

    public tableName(): string {
      return 'order-orderlines';
    }

    // METHODS
    public sideMenu(): any {
      const id = this.$route.params.transactionId;
      const sideMenu: any = {
        content: {
          title: {
            text: this.sideMenuData.title,
            mobile: {
              close: {
                text: 'Close',
                icon: invoicesIcon,
              },
            },
          },
          type: 'themed',
          sections: {
            main: {
              items: {
                back: {
                  title: 'Terug naar orders',
                  icon: returnIcon,
                  name: 'orders.overview',
                },
                customer: {
                  title: this.sideMenuData.customer ? this.sideMenuData.customer.label : '',
                  icon: customerIcon,
                  name: 'customers.edit',
                  params: this.sideMenuData.customer.params,
                },
                partition: {
                  title: this.sideMenuData.partition ? this.sideMenuData.partition.label : '',
                  icon: globeIcon,
                  name: 'provisioning.partition.info',
                  params: this.sideMenuData.partition.params,
                },
              },
            },
            info: {
              title: 'Informatie order',
              items: {
                simCount: {
                  title: `Simkaarten tellen (${this.simCardCount})`,
                  icon: statusIcon,
                  readonly: true,
                },
              },
            },
            filters: {
              title: 'Sorteren op status',
              items: {
                all: {
                  title: `Alle (${this.getTotalStatusCount()})`,
                  icon: ordersIcon,
                  name: 'orders.orderlines',
                  params: {transactionId: id},
                },
                received: {
                  title: `In uitvoering (${this.getStatusCount('inuitvoering')})`,
                  icon: statusIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'inuitvoering', transactionId: id},
                },
                accepted: {
                  title: `Geaccepteerd (${this.getStatusCount('geaccepteerd')})`,
                  icon: wonIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'geaccepteerd', transactionId: id},
                },
                onhold: {
                  title: `On hold (${this.getStatusCount('onhold')})`,
                  icon: clockIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'onhold', transactionId: id},
                },
                planned: {
                  title: `Gepland (${this.getStatusCount('gepland')})`,
                  icon: calendarTimeIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'gepland', transactionId: id},
                },
                delivered: {
                  title: `Facturatie (${this.getStatusCount('facturatie')})`,
                  icon: checkmarkIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'facturatie', transactionId: id},
                },
                cancelled: {
                  title: `Opgezegd (${this.getStatusCount('opgezegd')})`,
                  icon: warningIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'opgezegd', transactionId: id},
                },
                terminated: {
                  title: `Beëindigd (${this.getStatusCount('beeindigd')})`,
                  icon: deleteIcon,
                  name: 'orders.orderlines.status',
                  params: {status: 'beeindigd', transactionId: id},
                },
              },
            },
          },
        },
      };

      if (authUserHasPrivilegeAndAction(UserPrivilege.PARTNER, UserAction.VIEW)) {
        sideMenu.content.sections.main.items.partner = {
          title: this.sideMenuData.partner.label,
          icon: partnerIcon,
          name: 'partners.edit',
          params: this.sideMenuData.partner.params,
        };
      }

      if (this.canChangeOrderStatus()) {
        sideMenu.content.sections.changeStatus = {
          title: 'Status wijzigen productgroep',
            items: {
            cloud: {
              title: 'Cloud',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.CLOUD, 'Cloud'),
            },
            sipTrunk: {
              title: 'SIP Trunk',
              icon: statusIcon,
              name: 'OrderChangeStatus',
              params: this.changeStatusParams(ServiceTagEnum.SIP_TRUNK, 'SIP Trunk'),
            },
            newPhoneNumbers: {
              title: 'Nieuwe telefoonnummers',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.PHONE_NUMBERS_NEW, 'Nieuwe telefoonnummers'),
            },
            portingPhoneNumbers: {
              title: 'Te porteren telefoonnummers',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.PHONE_NUMBERS_PORTING, 'Te porteren telefoonnummers'),
            },
            internetLine: {
              title: 'Connection producten',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.CONNECTION, 'Connection') ,
            },
            hardware: {
              title: 'Hardware',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.HARDWARE, 'Hardware'),
            },
            mobile: {
              title: 'Mobile Odido',
                icon: statusIcon,
                name: 'OrderChangeStatus',
                params: this.changeStatusParams(ServiceTagEnum.MOBILE, 'Mobile Odido'),
            },
            mobileKpn: {
              title: 'Mobile KPN',
              icon: statusIcon,
              name: 'OrderChangeStatus',
              params: this.changeStatusParams(ServiceTagEnum.MOBILE_KPN, 'Mobile KPN'),
            },
          },
        };
      }

      return sideMenu;
    }

    public changeStatusParams(tag: string, title: string): object {
      return {
        modal: true,
        tag,
        title,
        isChangeSingle: false,
        id: this.$route.params.transactionId,
        invoiceDate: this.invoiceDate,
      };
    }

    public cellClick(target: { cell: object, row: { cpId: string }, column: string }) {
      if (authUserHasPrivilegeAndAction(UserPrivilege.ORDERLINE, UserAction.VIEW)) {
        this.$router.push({
          name: 'orders.orderline',
          params: {
            transactionId: this.$route.params.transactionId,
            cpId: target.row.cpId,
          },
        });
      }
    }

    public async loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);
      this.enableCancelling = false;

      try {
        const orderInfoEndpoint: string = '/-/trade/api/order.info';

        const orderInfoResponse = await axios.post(orderInfoEndpoint, {
          transactionId: this.$route.params.transactionId,
        });

        if (orderInfoResponse.data != undefined) {
          const order = orderInfoResponse.data;

          this.customerId = order.customer.id;
          this.orderLineCounts = order.orderLineStatusCounts;
          this.simCardCount = order.simCardCount;
          this.hasFailedMobileProvisionings = order.hasFailedMobileProvisionings;

          this.sideMenuData = {
            title: 'Order ' + order.orderCode,
            customer: {
              label: `Klant (${order.customer.name})`,
              params: {
                id: order.customer.id,
              },
            },
            partition: {
              label: `Cloud PBX (${order.customer.name})`,
              params: {
                customerId: order.customer.id,
              },
            },
            partner: {
              label: `Partner (${order.partner.name})`,
              params: {
                pid: order.partner.id,
              },
            },
          };

          this.$store.dispatch('updateSideMenu', this.sideMenu());
        }
      } catch (err) {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        this.$store.dispatch('setLoadOverlay', false);
        return;
      }

      try {
        const orderLineListEndpoint = '/-/trade/api/order.line.list';

        const orderLineListResponse = await axios.post(orderLineListEndpoint, {
          transactionId: this.$route.params.transactionId,
          meta: {
            startIndex: ((data.pageNumber - 1) * data.itemsPerPage),
            numberOfItems: data.itemsPerPage,
          },
          sort: data.sort,
          status: data.status,
        });

        if (orderLineListResponse.data.data != undefined) {
          this.data = orderLineListResponse.data.data.map((orderLine: any) => {
            this.setCancelling(orderLine);

            const productName = this.getProductName(orderLine);
            const phoneNumbers = this.getPhoneNumbers(orderLine);

            if (this.invoiceDate === '') {
              this.invoiceDate = orderLine.invoiceDate;
            }

            if (!this.customerId) {
              this.customerId = orderLine.customerId;
            }

            return {
              cpId: orderLine.id,
              isMainProduct: orderLine.isMainProduct,
              productName,
              connectAmount: formatPrice(orderLine.connectAmount),
              recurrentAmount: formatPrice(orderLine.recurrentAmount),
              wishDate: getDutchDateFormat(orderLine.statusDates.wishDate),
              deliveryDate: getDutchDateFormat(orderLine.statusDates.deliveryDate),
              invoiceDate: getDutchDateFormat(orderLine.statusDates.invoiceDate),
              terminationRequestDate: getDutchDateFormat(orderLine.statusDates.terminationRequestDate),
              phoneNumbers,
              status: statusStringToIcons(orderLine.status.icon),
              statusId: orderLine.status.id,
              statusName: orderLine.status.name,
              isProvisionable: orderLine.product.isProvisionable,
              serviceName: orderLine.service.name,
            };
          });

          this.updateMeta(orderLineListResponse.data.meta);
        }

      } catch (err) {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        this.$store.dispatch('setLoadOverlay', false);
        return;
      }

      try {
        const customerInfoEndpoint = '/-/trade/api/customer.info';

        const customerInfoResponse = await axios.post(customerInfoEndpoint, {
          customerId: this.customerId,
        });

        if (customerInfoResponse.data.partitionId === null) {
          this.$store.dispatch('setLoadOverlay', false);

          return;
        }

        this.partitionDetails.identifier = customerInfoResponse.data.partitionId;
      } catch (err) {
        this.$store.dispatch('setLoadOverlay', false);
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        return;
      }

      // call partition info only for cloud and sip
      const requiresPartitionData = this.orderlinesData.some(
          (item: any) =>
              item.serviceName === ServiceTypeEnum.CLOUD ||
              item.serviceName === ServiceTypeEnum.SIP_TRUNK
      );

      if (requiresPartitionData) {
        const partitionInfoEndpoint = '/-/trade/api/provisioning.partition.info';

        try {
          const partitionInfoResponse = await axios.post(partitionInfoEndpoint, {
            partitionId: this.partitionDetails.identifier,
          });

          if (partitionInfoResponse?.data !== undefined) {
            this.partitionDetails.identifier = partitionInfoResponse.data.identifier;
            this.partitionDetails.status = partitionInfoResponse.data.status;
            this.partner.email = partitionInfoResponse.data.partner.email;
            this.partitionDetails.PBXGroupIdentifier = partitionInfoResponse.data.PBXGroup.id;

            this.provisioningAvailable = true;
          }


        } catch (err) {
          this.$toast(this.$store.state.main.notification.messages.provisioningNotAvailable);
        }
      }

      this.$store.dispatch('setLoadOverlay', false);
    }


    public addOrderline() {
      deanDialogBus.$emit('open', 'OrderAddOrderlineDialog', {
        id: this.$route.params.transactionId,
        customerId: this.sideMenuData.customer.params.id,
      });
    }

    public transferOrderLines(): void
    {
      deanDialogBus.$emit('open', 'OrderMigrateOrderLinesDialog', {
        orderId: this.$route.params.transactionId,
      });
    }

    public createPartition(): void
    {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/provisioning.partition.creation.request', {
        customerId: this.customerId,
        orderId: this.$route.params.transactionId,
      })
        .then(
        (response: any) => {
          this.$store.dispatch('setLoadOverlay', false);

          const partitionInfoResponse: any = response.data;

          this.partitionDetails.identifier = partitionInfoResponse.identifier;
          this.partitionDetails.status = partitionInfoResponse.status;
          this.partner.email = partitionInfoResponse.partner.email;
          this.partitionDetails.PBXGroupIdentifier = partitionInfoResponse.PBXGroup?.id;

          this.$toast({
            icon: saveIcon,
            text: String(this.$t('messages.partitionCreated')),
            theme: 'success',
          });

          this.loadList([]);
        },
        (error: any) => {
          this.partitionCreationFailed = true;

          this.$store.dispatch('setLoadOverlay', false);

          const errorMessage: string|null = getErrorMessageFromResponse(
              error.response.data,
              'Request failed.'
          )

          this.$toast({
            icon: warningIcon,
            text: errorMessage ?? '',
            theme: 'danger',
          });
      });
    }

    public retryMobileProvisioning(): void
    {
      this.$store.dispatch('setLoadOverlay', true);

      axios.post('/-/trade/api/mobile.order.retry.provisioning', {
        orderId: this.$route.params.transactionId,
      })
      .then(
          (response: any) => {
            this.$store.dispatch('setLoadOverlay', false);

            this.$toast({
              icon: saveIcon,
              text: String(this.$t('messages.retryMobileProvisioning')),
              theme: 'success',
            });

            this.loadList([]);
          },
          (error: any) => {
            this.$store.dispatch('setLoadOverlay', false);

            let errorMessage: string|null = getErrorFromResponse(
                error.response.data,
                'Request failed.'
            )

            const errorCode: string|null = getErrorCodeFromResponse(
                error.response.data,
            );

            if (
                errorCode === 'ERR_RETRY_PROVISIONING_PORTING_DEADLINE_PASSED'
                ||
                errorCode === 'ERR_PORTING_DATE_PASSED'
            ) {
              // extract uuid from err message
              const uuidRegex = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/i;

              const errorMessageOrderLineId = error.response.data.errors.message.match(uuidRegex)[0];

              const orderLine = this.orderlinesData.find((o: any) => o.cpId === errorMessageOrderLineId);

              errorMessage += ': ' + orderLine.productName;
            }

            this.$toast({
              icon: warningIcon,
              text: errorMessage ?? '',
              theme: 'danger',
            });
          });
    }

    public provisionServices(): void
    {
      if (this.showServiceProvisioningDialog()) {
        deanDialogBus.$emit('open', 'provisionServicesDialog', {
          customerId: this.customerId,
          orderId: this.$route.params.transactionId,
          partitionId: this.partitionDetails.identifier,
          partnerEmail: this.partner.email,
        });
      } else {
        this.$store.dispatch('setLoadOverlay', true);

        axios.post('/-/trade/api/provisioning.provision.services', {
          customerId: this.customerId,
          orderId: this.$route.params.transactionId,
          partitionId: this.partitionDetails.identifier,
        }).then(
            (response: any) => {
              this.$store.dispatch('setLoadOverlay', false);

              this.$toast(this.$store.state.main.notification.messages.dataSaved);
            },
            (error: any) => {
              this.$store.dispatch('setLoadOverlay', false);

              const errorMessage: string|null = getErrorMessageFromResponse(
                  error.response.data,
                  'Request failed.'
              )

              this.$toast({
                icon: warningIcon,
                text: errorMessage ?? '',
                theme: 'danger',
              });
            },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      }
    }

    public importOdidoOrderLines() {
      deanDialogBus.$emit('open', 'OrderImportOrderlinesDialog', {
        orderId: this.$route.params.transactionId,
        customerId: this.sideMenuData.customer.params.id,
        partnerId: this.sideMenuData.partner.params.pid,
      });
    }

    public cancelEntireOrder() {
      deanDialogBus.$emit('open', 'OrderCancelOrderlineDialog', {
        data: this.$route.params.transactionId,
        mode: 'all',
      });
    }


    public created() {
      this.setDefaultSort('status');
      this.pageMeta.status = this.translateStatus(this.$route.params.status);
      this.loadList(this.pageMeta);
    }

    public mounted() {
      deanDialogBus.$on('saved', (payload: any) => {
        this.loadList(this.pageMeta);
      });
    }

    public destroyed() {
      deanDialogBus.$off('saved');
    }

    private translateStatus(status: string) {
      const translateMap = new Map();
      translateMap.set('inuitvoering', OrderStatusEnum.IN_PROGRESS);
      translateMap.set('geaccepteerd', OrderStatusEnum.ACCEPTED);
      translateMap.set('gepland', OrderStatusEnum.PLANNED);
      translateMap.set('onhold', OrderStatusEnum.ON_HOLD);
      translateMap.set('facturatie', OrderStatusEnum.INVOICED);
      translateMap.set('opgezegd', OrderStatusEnum.TERMINATION_REQUESTED);
      translateMap.set('beeindigd', OrderStatusEnum.TERMINATED);

      return translateMap.has(status) ? translateMap.get(status) : '';
    }

    private getStatusCount(status: string) {
      const filteredAmount: any = Object.values(this.orderLineCounts).filter((count: any) => {
        return count.name === status;
      });

      return filteredAmount.length ? filteredAmount[0].count : 0;
    }

    private getTotalStatusCount() {
      const counts: any = Object.values(this.orderLineCounts).map((count: any) => count.count);
      const reduceToSum = (previousCount: number, currentCount: number) => previousCount + currentCount;

      return counts.reduce(reduceToSum, 0);
    }

    private getProductName(orderLine: any): string {
      let productName = orderLine.product.class
          ? `${orderLine.product.class} - ${orderLine.product.name}` : orderLine.product.name;

      if (orderLine?.additionalData === null || orderLine?.additionalData === undefined) {
        return productName;
      }

      let phoneNumber = getPhoneNumberFromOrderLine(orderLine);

      if (phoneNumber) {
        productName += ` (${phoneNumber})`;
      }

      return productName;
    }

    private getPhoneNumbers(orderLine: any): string {
      if (orderLine?.additionalData === null || orderLine?.additionalData === undefined) {
        return '-';
      }

      if (orderLine.additionalData.phoneNumberRangeFrom && orderLine.additionalData.phoneNumberRangeTo) {
        return orderLine.additionalData.phoneNumberRangeFrom + ' - ' + orderLine.additionalData.phoneNumberRangeTo;
      }

      if (orderLine.additionalData.phoneNumber) {
        return orderLine.additionalData.phoneNumber;
      }

      return '-';
    }

    private orderContainsProvisionableProduct(): boolean
    {
      for (let index in this.data) {
        if (this.data[index].isProvisionable) {

          return true;
        }
      }

      return false;
    }

    private orderLinesWithProvisionableProductsAreInStatus(statuses: [string, string, string]): boolean
    {
      for (let index in this.data) {
        if (!this.data[index].isProvisionable) {
          continue;
        }

        if (statuses.includes(this.data[index].statusName)) {
          return true;
        }
      }

      return false;
    }
  }
</script>

<!-- STYLE -->
<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
